export const allowedImageTypes = ['image/jpeg', 'image/png']

export const isAllowedImage = (type: string) => allowedImageTypes.includes(type)
